export const VIEWPORT_HEIGHT_REFRESH_EVENT = 'sitelife:viewport-height-refresh';

export function measureViewportHeight(): number | null {
  if (typeof window === 'undefined') {
    return null;
  }

  // Intentionally NOT using visualViewport.height: it shrinks while the
  // on-screen keyboard is open and, on iOS Safari, can stay short right after
  // the keyboard dismisses. clientHeight / innerHeight are keyboard-independent.
  return document.documentElement?.clientHeight || window.innerHeight;
}

/** Force app shell and fixed UI to remeasure after modal / keyboard interactions. */
export function refreshViewportHeight(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const dispatch = () =>
    window.dispatchEvent(new Event(VIEWPORT_HEIGHT_REFRESH_EVENT));

  dispatch();
  requestAnimationFrame(() => {
    dispatch();
    requestAnimationFrame(dispatch);
  });
}
